import validate from "/builds/devhacker/lh-website-client/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.0_@types+node@22.15.17_db0@0.3.2_eslint@9.39.2_jiti@2.4_e4640a7bd66a3e4e181546c577e2f4bc/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45redirect_45global from "/builds/devhacker/lh-website-client/middleware/01.redirect.global.ts";
import _02_45error404_45global from "/builds/devhacker/lh-website-client/middleware/02.error404.global.ts";
import _03_45app_45data_45global from "/builds/devhacker/lh-website-client/middleware/03.appData.global.ts";
import _04_45fetch_45archive_45page_45data_45global from "/builds/devhacker/lh-website-client/middleware/04.fetchArchivePageData.global.ts";
import _05_45fetch_45single_45article_45page_45data_45global from "/builds/devhacker/lh-website-client/middleware/05.fetchSingleArticlePageData.global.ts";
export const globalMiddleware = [
  validate,
  _01_45redirect_45global,
  _02_45error404_45global,
  _03_45app_45data_45global,
  _04_45fetch_45archive_45page_45data_45global,
  _05_45fetch_45single_45article_45page_45data_45global
]
export const namedMiddleware = {
  "fetch-recipe-data": () => import("/builds/devhacker/lh-website-client/middleware/fetchRecipeData.ts")
}